exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-switch.is-disabled[data-v-f3af3f14]{opacity:1}[data-v-f3af3f14] .el-switch__label{cursor:pointer !important}.total-th[data-v-f3af3f14]{margin-bottom:30px;color:#0256ff;font-size:14px}.total-top[data-v-f3af3f14]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-line-pack:center;align-content:center}.total-top li[data-v-f3af3f14]{width:20%;text-align:center;font-size:14px}.total-top li p[data-v-f3af3f14]:last-child{margin-top:30px}", ""]);

// exports
